<template>
  <div style="width: 100%;height: 100%;">
      <img class="h5-poster" :src="item.poster_img" :class="{'oct': showposter && indx ==tabIndex && item.preview_url.indexOf('m3u8') !== -1}"  />
      <div class="h5_video" :class="`h5_video${indx}`" v-show="indx == tabIndex">
        <div style="width: 100%;height: 100%;">
          <LoadPart v-show="isLoad"></LoadPart>
          <div class="main_video" :class="{'shows': isLoad == false}">
            <div :id="`xgplayer${indx}`"></div>
          </div>
          <span class="count">{{count}}s</span>
        </div>
      </div>
  </div>
</template>

<script>
import "xgplayer";
import HlsJsPlayer from "xgplayer-hls.js";
import { mapActions, mapState } from 'vuex';
import LoadPart from "@/components/Load/LoadPart";

export default {
  name: "xgplayerVideo",
  data() {
    return {
      player: null,
      isLoad: true,
      count: null,
      timer: null,
      showposter:false
    };
  },
  props: {
    videos: {
      type: String, default: ''
    },
    url: {
      type: String,
      default: ""
    },
    item:{
      type: Object,
      default: ""
    },
    indx: { type: Number },
    tabIndex: { type: Number }
  },
  mounted() {
    if (this.tabIndex==this.indx) {
      this.init(this.videos, this.indx,true);
    }
    setTimeout( async () => {
      this.showposter = true
    },3000);
  },
  computed: {
    ...mapState({

    }),
  },
  methods: {
    ...mapActions({
      SetLoadStatusFn: "SetLoadStatusFn",
      SubmitTimeUpdateFn: "SubmitTimeUpdateFn",
      getTimeUpdateFn: "getTimeUpdateFn",
    }),
    init(videos, tabIndex, autoplay = false) {
      let locale = window.localStorage.getItem("locale") || 1, lang = '';
      if (locale == 1) {
        lang = 'en'
      } else if (locale == 2) {
        lang = 'zh-cn'
      } else {
        lang = 'jp'
      }
      this.$nextTick(() => {
        let THIS = this
        this.timer = setInterval(() => {
            THIS.count++;
        }, 1000)
        if (this.appSource() == "ios" || this.device == 'mob') {
          this.player = new HlsJsPlayer({
            id: "xgplayer" + tabIndex,
            // lang: lang,
            // url: 'https://qzvd-newblibli3.10cb1c.com/20221020/ZDA3MWNlYz/180226/1080/hls/decrypt/index.m3u8',
            url: this.url,
            autoplay: autoplay,
            autoplayMuted: true,
            controls: false,
            preloadTime: 15,  // 预加载时长
            fluid: true,
            fitVideoSize: 'fixWidth',
            Muted: true,
            loop: true,
            playbackRate: [0.5, 0.75, 1, 1.5, 2],
            ignores: ['replay'],
            width: '100vw',
            height: '100vw',
            volume: 0.6,
            // poster: videos,
            // maxBufferLength: 20,
            // crossOrigin: true,
            keyShortcut: 'on',
            keyShortcutStep: { //设置调整步长
              currentTime: 15, //播放进度调整步长，默认10秒
              volume: 0.2 //音量调整步长，默认0.1
            },
            'x5-video-player-type': 'h5', // 微信内置浏览器设置，防止被浏览器劫持
            'x5-video-orientation': 'landscape',
            'x5-video-player-fullscreen': true,

            // textTrack: textTrack,
            // textTrackActive: 'click',
            closeVideoTouch: true,
            playsinline: true,
            whitelist: ['iPhone', 'Android'],
          });
          this.player.once('canplay', (res) => {
            clearInterval(this.timer);
            if (THIS.count>2){
              this.isLoad = false;
            }else if(THIS.count>1){
              setTimeout(async () => {
                this.isLoad = false;
              }, 1000);
            }else if(THIS.count>0){
              setTimeout(async () => {
                this.isLoad = false;
              }, 2000);
            }else{
              setTimeout(async () => {
                this.isLoad = false;
              }, 3000);
            }
          });
        }
      });
    },
    appSource() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        return "ios";
      } else {
        return "andriod";
      }
    },
  },
  watch: {
    tabIndex(newVal, oldVal) {
      this.showposter = false
      if (this.player){
        this.player.pause();
        if (newVal==this.indx) {
          setTimeout( async () => {
            this.showposter = true
              this.player.play()
          },3000);
        }
      }else{
        if (newVal==this.indx) {
          this.isLoad = true;
          setTimeout( async () => {
            this.showposter = true
            this.init(this.videos, this.indx,true);
          },3000);
        }
      }
    },
    deep: true
  },
  components: {
    LoadPart
  },
  destroyed() {
    if (this.player) {
      this.player.hls.destroy()
      this.player.destroy()
    }
  },
}
</script>

<style  scoped>
.count{
  visibility: hidden;
}
.shows{
  visibility: visible !important;
}
::v-deep .loading-main{
  background: 0;
}
::v-deep .xgplayer-texttrack .name {
  left: 0;
}
.main_video {
  margin: 0 auto;
  text-align: center;
  height: 100%;
  width: 100%;
  visibility: hidden;
}

::v-deep .xgplayer-texttrack .name {
  left: 0;
}

::v-deep .xgplayer-skin-default {
  /* min-height: 300px; */
  width: 100vw !important;
  height: 100vh !important;
}

::v-deep .xgplayer-skin-default .xgplayer-pip .name span {
  padding: 0 20px;
  width: auto;
}

@media screen and (max-width:760px) {
  ::v-deep .xgplayer-skin-default {
    width: 100% !important;
    height: 100% !important
  }

  .xgplayer-skin-default.xgplayer-is-enter .xgplayer-enter {
    display: none;
}

  ::v-deep .xgplayer-skin-default .xgplayer-pip .name span {
    padding: 0px;
  }

  ::v-deep .xgplayer-skin-default .xgplayer-time {
    margin: 0
  }

  ::v-deep .xgplayer-skin-default .xgplayer-progress {
    width: 88%;
    left: 10%;
  }
  ::v-deep .xgplayer-skin-default.xgplayer-pause .xgplayer-start{
    display: none;
  }
}
</style>


